import * as React from "react";
import { singleton } from "logic/singleton";
const WindowDimensionsContext = React.createContext(void 0);
export default singleton("contexts.WindowDimensionsContext", () => WindowDimensionsContext);
